import { required, minimum, maximum } from 'shared/utils/validators';

export const constraints = (min: number, max: number) => ({
  amount: [required(), minimum(min), maximum(max)],
});

export interface FormData {
  amount: string;
}
